import { CheckCircle, HourglassEmpty, Cancel as CancelIcon, Visibility, ReceiptLong } from "@mui/icons-material";
import { alpha, Chip, Stack, useTheme, Box } from "@mui/material";
import React from "react";

export type StatusInstallment = "paid" | "pending" | "canceled" | "billed" | "imported" | string;

interface StatusInstallmentChipProps {
  status: StatusInstallment;
  darkMode?: boolean;
  label?: string;
}

export const statusColorsInstallment = (theme: any, isDarkMode: boolean) => ({
  paid: {
    bg: isDarkMode ? alpha(theme.palette.success.main, 0.1) : "#f0fdf4",
    color: theme.palette.success.main,
    icon: <CheckCircle fontSize="small" sx={{ color: theme.palette.success.main }} />,
  },
  pending: {
    bg: isDarkMode ? alpha(theme.palette.warning.main, 0.1) : "#fffbe6",
    color: theme.palette.warning.main,
    icon: <HourglassEmpty fontSize="small" sx={{ color: theme.palette.warning.main }} />,
  },
  canceled: {
    bg: isDarkMode ? alpha(theme.palette.error.main, 0.1) : "#fef2f2",
    color: theme.palette.error.main,
    icon: <CancelIcon fontSize="small" sx={{ color: theme.palette.error.main }} />,
  },
  billed: {
    bg: isDarkMode ? alpha(theme.palette.info.main, 0.1) : "#eef2ff",
    color: theme.palette.info.main,
    icon: <Visibility fontSize="small" sx={{ color: theme.palette.info.main }} />,
  },
  imported: {
    bg: isDarkMode ? alpha(theme.palette.common.white, 0.06) : "#f3f4f6",
    color: isDarkMode ? theme.palette.text.primary : "#383838",
    icon: <ReceiptLong fontSize="small" sx={{ color: isDarkMode ? theme.palette.text.primary : "#383838" }} />,
  },
});

const labelMap: Record<string, string> = {
  paid: "Pago",
  pending: "Pendente",
  canceled: "Cancelada",
  imported: "Importado",
  billed: "Faturado",
};

export const StatusInstallmentChip: React.FC<StatusInstallmentChipProps> = ({ status, label }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const colorMap = statusColorsInstallment(theme, isDarkMode);
  const colors = colorMap[status as keyof typeof colorMap] ?? colorMap.imported;
  const chipLabel = label || labelMap[status] || status;

  if (!status || !colors) return <Box sx={{ width: 70, height: 24 }} />;

  return (
    <Chip
      label={
        <Stack direction="row" alignItems="center" gap={0.5}>
          {colors.icon}
          {chipLabel}
        </Stack>
      }
      size="small"
      sx={{
        fontWeight: 400,
        borderRadius: 2,
        backgroundColor: colors.bg,
        color: colors.color,
      }}
    />
  );
};
